<template>
  <div class="">
    <h1>Unauthorized</h1>
  </div>
</template>
